module.exports = __webpack_public_path__ + "static/img/img-nav2.1ae32593.png";